import { render, staticRenderFns } from "./AddNewVenue.vue?vue&type=template&id=dac2110c&"
import script from "./AddNewVenue.vue?vue&type=script&lang=ts&"
export * from "./AddNewVenue.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewVenue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports